export default function VoteIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
			<path
				d="M7.93939 1.86365C6.82461 1.86365 5.89027 4.06181 5.17983 5.50352C5.01825 5.83143 4.68175 6.03031 4.3162 6.03031H2.5C1.94772 6.03031 1.5 6.47803 1.5 7.03031V12.2273C1.5 12.7796 1.94772 13.2273 2.5 13.2273H10.6279C11.2824 13.2273 11.8612 12.803 12.0583 12.179L13.3837 7.98201C13.689 7.01523 12.9673 6.03031 11.9535 6.03031H10.2698C9.53745 6.03031 9.06126 5.26419 9.227 4.55083C9.63328 2.80218 8.94723 1.86365 7.93939 1.86365Z"
				stroke="currentColor"
				strokeWidth="1.2"
			/>
			<line x1="4.75186" y1="5.65152" x2="4.75186" y2="13.2273" stroke="currentColor" strokeWidth="1.2" />
		</svg>
	);
}
